<div class="container" id="wrapper">
    <div class="row">
        <div class="col-lg-12">
            <img src="../../../assets/Logo.png" width="200px">
            <h3 style="color: white !important;">Synergy Technology</h3>
            <p style="color: darkgray; text-align: right;">XmartBusiness 3.0</p>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-8">
            <br>
            <p style="color: white; font-family: Arial; font-size: 12px; text-align: justify;">Bienvenido a
                XmartBusiness nuestro sistema en linea de punto de venta, administracion de inventarios y factuacion
                electronica para Costa Rica.
                Con XmartBusiness usted podra aministrar de forma seguro y efeciancia su negocio de venta de bienes
                y
                servicios. Registrese con nosotros y permitanos ser el mejor aliado tecnologico para su negocio.
            </p>
        </div>
        <div class="col-lg-4" style="font-size: 10px; padding: 1px;">
            <syn-login-form *ngIf="!authenticationService.IsAuthenticated()" style="font-size: 10px; padding: 1px;"
                logoURL="../../../assets/Logo700x400.png" (onLogIn)="onLog($event)"
                passwordForgottenURL="PasswordForgotten"></syn-login-form>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            &nbsp;
            &nbsp;
            &nbsp;
            &nbsp;
        </div>
        <div class="col-lg-12">
        </div>
        <div class="col-lg-12">
        </div>
        <div class="col-lg-12">
        </div>
    </div>
</div>
<synergy-footer></synergy-footer>
<p-toast [style]="{marginTop: '100px'}" position="top-center" key="tc" [hideTransitionOptions]="'1ms'">
</p-toast>